import React, { useCallback, useEffect, useState } from "react";
import { Col, Container } from "reactstrap";
import MetaData from "components/VerticalLayout/MetaData";
import { defaultNgiErrorMethod, warnMessage } from "components/Common/responses/message";
import NGITable from "components/Common/NGITable";
import { FILTER_PAGE } from "utils/constants";
import useStoreFilters from "customHooks/useStoreFilters";
import { useDispatch } from "react-redux";
import { getFirmwares } from "store/meter-management/configuration/firmware/actions";
import MetersFirmwareUpdateHistoryFilter from "pages/meter-management/firmware/metersFirmwareUpdateHistory/MetersFirmwareUpdateHistoryFilter";
import { metersFirmwareUpdateHistoryColumns } from "pages/meter-management/firmware/metersFirmwareUpdateHistory/metersFirmwareUpdateHistoryColumns";
import { getMetersFirmwareHistory } from "utils/api";

const MetersFirmwareUpdateHistory = () => {
  const dispatch = useDispatch();
  const [isLoading, setLoader] = useState(false);
  const { setFilters, filters } = useStoreFilters(FILTER_PAGE.METERS_FIRMWARE_HISTORY);
  const [list, setList] = useState({});
  useEffect(() => {
    dispatch(getFirmwares());
  }, []);

  const handleFilter = useCallback((newFilterOptions = filters) => {
    setLoader(true);
    setFilters(newFilterOptions);
    getMetersFirmwareHistory({
      ...newFilterOptions,
    })
      .then(res => {
        const {
          result: { items },
        } = res?.data;
        if (items.length === 0) {
          warnMessage("No items were found");
          setLoader(false);
        }
        setList(res?.data || null);
        setLoader(false);
      })
      .catch(err => {
        setLoader(false);
        setList({});
        defaultNgiErrorMethod(err);
      });
  }, []);

  return (
    <>
      <div className="page-content" data-testid="metersComponent">
        <MetaData pageTitle={"Meters Firmware Update History"} />
        <Container fluid>
          <div className="filters-wrapper">
            <MetersFirmwareUpdateHistoryFilter handleFilter={handleFilter} />
          </div>
          <Col lg={12}>
            <NGITable
              filtersType={FILTER_PAGE.METERS_FIRMWARE_HISTORY}
              isLoading={isLoading}
              columns={metersFirmwareUpdateHistoryColumns}
              data={list}
              updateList={handleFilter}
            />
          </Col>
        </Container>
      </div>
    </>
  );
};

export default MetersFirmwareUpdateHistory;
